import React, { useState } from 'react';
import {
  FaArrowCircleRight,
  FaChevronDown,
  FaChevronUp,
  FaLock,
} from 'react-icons/fa';
import { Button, Collapse } from 'reactstrap';

type RenderTitleProps = {
  title: React.ReactNode;
  collapsable?: boolean;
  locked?: boolean;
  isCollapsed?: boolean;
};

const RenderTitle = ({
  title,
  collapsable,
  locked,
  isCollapsed,
}: RenderTitleProps) => {
  return (
    <h2 className="content-section-title">
      {locked && <FaLock className="me-2" />}

      {/* Default */}
      {!locked && <FaArrowCircleRight className="me-2" />}

      {title}

      {(collapsable || isCollapsed) &&
        (isCollapsed ? (
          <FaChevronDown className="ms-auto" />
        ) : (
          <FaChevronUp className="ms-auto" />
        ))}
    </h2>
  );
};

type ContentSectionProps = {
  title: React.ReactNode;
  children?: React.ReactNode;
  collapsable?: boolean;
  collapsed?: boolean;
  locked?: boolean;
  'data-use-bs'?: boolean;
};

export const ContentSection = (props: ContentSectionProps) => {
  const {
    children,
    collapsable = true,
    collapsed = false,
    title,
    locked = false,
    'data-use-bs': dataUseBs = false,
  } = props;

  // Local states
  const [isCollapsed, setIsCollapsed] = useState(
    collapsable ? collapsed : false,
  );

  return (
    <div
      className="d-flex flex-column align-items-start content-section"
      {...(dataUseBs ? { 'data-use-bs': true } : {})}
    >
      {!collapsable && (
        <div className="d-flex p-0">
          <RenderTitle
            title={title}
            locked={locked}
            collapsable={collapsable}
            isCollapsed={isCollapsed}
          />
        </div>
      )}

      {collapsable && (
        <Button
          className="d-flex p-0"
          color="link"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <RenderTitle
            title={title}
            locked={locked}
            collapsable={collapsable}
            isCollapsed={isCollapsed}
          />
        </Button>
      )}

      <Collapse isOpen={!isCollapsed}>
        <div className={'inner-content'}>{children}</div>
      </Collapse>
    </div>
  );
};
